'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Group } from '@mantine/core';

// Style
import * as classes from './styles/index.css';
import { Link } from 'react-router-dom';
import Highlight from '@app/shared/ui-kit/atoms/Highlight';
import useWorkspace from '@app/features/Workspace/store/hooks/useWorkspace';
import ResourceIcon from '@app/features/Resource/ResourceIcon';
import { resourceFileImageMimeTypes } from '@app/features/Resource/ResourceIcon/getFileIcon';
import { ResourceMimeType } from '@app/types/blackroom-app/resourceMimeType';
import { MatchResourceItemProps } from './types';
import { useMemo } from 'react';
import { ResourceType } from '@app/types/blackroom-api';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
function MatchResourceItem({
  resource,
  query = '',
  onClick,
}: MatchResourceItemProps) {
  const workspace = useWorkspace();

  const resourceUrl = useMemo(() => {
    if (resource.type === ResourceType.File) {
      return `/workspace/${workspace.id}/file/${resource.id}`;
    }

    return `/workspace/${workspace.id}/resources/my/${resource.id}`;
  }, [workspace, resource]);

  /* ******************************** RENDERING ******************************* */
  return (
    <Link
      key={resource.id}
      className={classes.link}
      to={resourceUrl}
      onClick={onClick}
    >
      <Group gap={6} wrap="nowrap" w="100%">
        <ResourceIcon
          variant={resource.type === 'folder' ? 'filled' : undefined}
          resource={{
            type: resource.type!,
            mimeType: resource.mimeType,
          }}
          size={21}
          withColor={
            !!(
              resource.mimeType &&
              !resourceFileImageMimeTypes.includes(
                resource.mimeType as ResourceMimeType,
              )
            )
          }
        />
        {resource.index && (
          <Highlight highlight={query} truncate fz="sm">
            {resource.index}
          </Highlight>
        )}
        <Highlight highlight={query} truncate fz="sm" style={{ flex: 1 }}>
          {resource.name!}
        </Highlight>
      </Group>
    </Link>
  );
}

export default MatchResourceItem;
